import { userHasRight } from "../../../framework";
import K_Container from "../templates/K_Container";
import { Component, ComponentOptions, RightLockable } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface ContainerOptions extends ComponentOptions {
    components?: Component[];
    bsc?: string;
    style?: string;
    header?: string;
    observable?: any;
    label?: string;
    screenEntityName?: string;
    title?: string;
    readOnly?: boolean;
    readonly?: boolean;
    height?: number;
    labelBsc?: string;
    childBsc?: string;
    childInputBsc?: string;
    childLabelBsc?: string;
    entityType?: string;
    ScreenEntityType?: string;
    requiredRight?: string;
}

export class Container extends TemplateComponent {

    options: ContainerOptions & RightLockable;

    content: {
        components: Component[];
    };

    constructor(options: ContainerOptions) {
        super(K_Container, options);

        this.content = {
            components: options.components || []
        };
    }

    preRender() {
        const options = this.options;

        options.sectionName = options.id;
        options.screenEntityType = options.screenEntityType || "";

        if (options.requiredRight) {
            options.rightLocked = !userHasRight(options.requiredRight);

            if (options.rightLocked) {
                options.readOnly = true;
                options.containerClasses += "right-locked";
            }
        }
    }

    create() {
        $(`#${this.options.id}`).attr("screenentitytype", this.options.screenEntityType);
    }

}
